// "use client";

// import { Toaster } from "@/components/ui/sonner";
// import { useState, useEffect } from "react";
// import { usePathname } from "next/navigation";
// import Loader from "./Loader";

// export default function ClientLayout({ children }: { children: React.ReactNode }) {
//   const [loading, setLoading] = useState(false);
//   const pathname = usePathname();

//   useEffect(() => {
//     setLoading(true);
//     const timer = setTimeout(() => setLoading(false), 500); // Show loader for 500ms
//     return () => clearTimeout(timer);
//   }, [pathname]);

//   return (
//     <>
//       {loading && <Loader />}
//       <Toaster position="top-right" richColors />
//       {children}
//     </>
//   );
// }


"use client";

import { Toaster } from "@/components/ui/sonner";
import { QueryClientProvider } from "@tanstack/react-query";
import { initializeQueryClient } from "@/lib/queryClient";
import { useState } from "react";
import AgentChatDock from "@/components/chat/AgentChatDock";
import CustomerSupportDock from "@/components/chat/CustomerSupportDock";

export default function ClientLayout({ children }: { children: React.ReactNode }) {
  // Initialize QueryClient on the client side
  const [queryClient] = useState(() => initializeQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-right" richColors />
      {children}
      <AgentChatDock />
      <CustomerSupportDock />
    </QueryClientProvider>
  );
}
